import Http from './http'

// 查询轨迹
export const querySeaTrack = (params) =>
    Http.post('/track/querySeaTrack', {
        body: params,
    })
